document.addEventListener('DOMContentLoaded', function() {
  document.getElementById('menu-toggle').addEventListener('click', function() {
    const nav = document.getElementById('mobile-nav');
    nav.classList.toggle('mobile-nav-hidden');
    nav.classList.toggle('mobile-nav-open');
  });
});